<template>
  <div>
    <h1 class="mt-4">{{ $t("resetPassword") }}</h1>
    <p class="mt-4 text-center">
      <strong>{{ $t("passwordResetInfo") }}</strong>
    </p>
    <password-reset-form></password-reset-form>
    <p class="mt-5 mb-3 ml-3">
      <router-link to="/">{{ $t("back") }}</router-link>
    </p>
  </div>
</template>

<script>
import PasswordResetForm from "@/components/PasswordResetForm.vue";

export default {
  name: "PasswordResetView",
  components: {
    PasswordResetForm
  }
};
</script>
<style scoped lang="scss"></style>
